import { LanguageInput } from "../input/LanguageInput";
import { PHPResponse } from "../PHPResponse";
import { PHPAdress, PHPAdresses } from "../PHPAdress";
import { PHPRequest } from "../PHPRequest";
import { EmailInput } from "./UserSignUpRequest";

export type EMAIL = "EMAIL";
export type SESSIONS = "SESSIONS";
export type UserDataType = EMAIL | SESSIONS;

export class UserDataInput extends LanguageInput
{
  type:UserDataType;
}

export class UserDataResponse extends PHPResponse
{
  data:any;
}

export class UserDataRequest extends PHPRequest<PHPAdress,UserDataInput,UserDataResponse>
{
  static readonly ADRESS = PHPAdresses.USER_DATA;

  constructor(){ super( UserDataRequest.ADRESS ); }

}
